// extracted by mini-css-extract-plugin
export default {"buttonsWrap":"DocumentActions_buttonsWrap__Iql8y","confirmModal":"DocumentActions_confirmModal__wlWfy","buttonsModalWrap":"DocumentActions_buttonsModalWrap__zKSdF"};